import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { Home } from "lucide-react";
import "../../../assets/css/admin/AdminTopBar/AdminTopBar.css";

const AdminTopBar = ({ title, breadcrumbs = [] }) => {
  return (
    <div className="admin-topbar">
      <div className="topbar-content">
        <div>
          <h2 className="page-title">{title}</h2>

          <Breadcrumb className="admin-breadcrumb">
            <Breadcrumb.Item href="/admin-dashboard">
              <Home size={14} className="me-1" />
              
            </Breadcrumb.Item>

            {breadcrumbs.map((item, index) => (
              <Breadcrumb.Item
                key={index}
                href={item.href}
                active={item.current}
              >
                {item.label}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>
      </div>
    </div>
  );
};

export default AdminTopBar;
